import { Autocomplete, TextField } from "@mui/material";
import { INDUSTRIES } from "components/user/sign-in/states";

export const IndustryAutoComplete = (props: {
  value: string;
  onChange: () => {};
  setFieldValue: any;
  readOnly: boolean;
  disabled: boolean;
  error: boolean | undefined;
  helperText: string | false | undefined;
  size: "medium" | "small";
  label?: string;
}) => {
  const handleChange = (event: React.SyntheticEvent, value: string) => {
    props.setFieldValue("industry", value);
  };

  return (
    <Autocomplete
      fullWidth
      size={props.size}
      disableClearable
      disabled={props.disabled}
      readOnly={props.readOnly}
      value={props.value}
      onChange={handleChange}
      disablePortal
      id="industry"
      options={[...INDUSTRIES, ""]}
      renderInput={(params) => (
        <TextField
          value={props.value}
          {...params}
          label={props.label ?? "Industry"}
        />
      )}
    />
  );
};
